import { Data } from "effect";
import type { BusinessRuleViolationErrorData } from "./DomainError";

/**
 * General business rule violation error
 */
export class BusinessRuleViolationError extends Data.TaggedError("@/BusinessRuleViolationError")<BusinessRuleViolationErrorData> {}

/**
 * Error thrown when an operation would violate immutability constraints
 */
export class ImmutabilityViolationError extends Data.TaggedError("@/ImmutabilityViolationError")<
  BusinessRuleViolationErrorData & {
    readonly entityType: string;
    readonly entityId: string;
    readonly attemptedOperation: string;
  }
> {}

/**
 * Error thrown when uniqueness constraints are violated
 */
export class UniquenessViolationError extends Data.TaggedError("@/UniquenessViolationError")<
  BusinessRuleViolationErrorData & {
    readonly field: string;
    readonly value: string;
    readonly conflictingEntity?: string;
  }
> {}

/**
 * Error thrown when state transition is invalid
 */
export class InvalidStateTransitionError extends Data.TaggedError("@/InvalidStateTransitionError")<
  BusinessRuleViolationErrorData & {
    readonly entityType: string;
    readonly entityId: string;
    readonly currentState: string;
    readonly attemptedState: string;
    readonly allowedTransitions: string[];
  }
> {}

/**
 * Error thrown when operation is not allowed due to business rules
 */
export class OperationNotAllowedError extends Data.TaggedError("@/OperationNotAllowedError")<
  BusinessRuleViolationErrorData & {
    readonly operation: string;
    readonly reason: string;
    readonly entityType: string;
    readonly entityId: string;
  }
> {}

/**
 * Error thrown when financial calculations are incorrect
 */
export class FinancialCalculationError extends Data.TaggedError("@/FinancialCalculationError")<
  BusinessRuleViolationErrorData & {
    readonly calculationType: string;
    readonly expectedValue: number;
    readonly actualValue: number;
    readonly tolerance?: number;
  }
> {}

/**
 * Error thrown when currency operations are invalid
 */
export class CurrencyMismatchError extends Data.TaggedError("@/CurrencyMismatchError")<
  BusinessRuleViolationErrorData & {
    readonly expectedCurrency: string;
    readonly actualCurrency: string;
    readonly operation: string;
  }
> {}
